export default {
  version: 'rc',
  compilation: '296726'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1478
// module chunks = 22